import { render, staticRenderFns } from "./shopInventoryRecordDetail.vue?vue&type=template&id=d03c746c&scoped=true"
import script from "./shopInventoryRecordDetail.vue?vue&type=script&lang=js"
export * from "./shopInventoryRecordDetail.vue?vue&type=script&lang=js"
import style0 from "./shopInventoryRecordDetail.vue?vue&type=style&index=0&id=d03c746c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d03c746c",
  null
  
)

export default component.exports